export default __webpack_public_path__ + "static/media/qrcode.628c6245.svg";